import styled, { css } from 'styled-components';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

// eslint-disable-next-line import/prefer-default-export
export const TypographyStyled = styled(Typography)`
  ${({ theme }) => {
    return css`
      color: ${theme.colors.neutral.grayDark2};
    `;
  }
}`;

